module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/COB大连线.7a73b982.jpg";